/**
 * ============================================================================
 * EXPERIMENT: Travel Rhythm Display (ab_travel_rhythm)
 *
 * Backend-driven AB test — variant decided server-side via API
 * `meta.experiment.travelRhythm`. No Amplitude experiment, no entry in
 * `feature-flags.json`: the variant is implicit — the feature renders only
 * when the API returns a rhythm value.
 *
 * PR: #TODO_AFTER_PR_CREATION_ab_travel_rhythm
 * Expected end date: 2026-07-22 (remove all AB_* files and BEGIN/END markers by then).
 *
 * Temporary code — will be REMOVED when the experiment concludes.
 * Find all experiment code: grep -rn "ab_travel_rhythm" src/
 * ============================================================================
 */
import { useGetDossierData, useGetTripProject } from '../../../../resources/dossier/queries';
import { DossierId } from '../../../../resources/dossier/types';

import { AB_TravelRhythmModalView } from './AB_TravelRhythmModalView';
import { AB_useTravelRhythmModal } from './AB_useTravelRhythmModal';

type Props = { dossierId: DossierId };

export function AB_TravelRhythmModal({ dossierId }: Readonly<Props>) {
    const { dossier } = useGetDossierData(dossierId) || {};
    const { data } = useGetTripProject(dossierId, dossier?.project?.marketCode);
    const value = data?.experiment?.travelRhythm;
    const { shouldDisplay, dismiss } = AB_useTravelRhythmModal(dossierId, value);

    if (!shouldDisplay || !value) return null;

    return <AB_TravelRhythmModalView value={value} onDismiss={dismiss} />;
}
